const DEFAULT_CURRENCY = 'INR';
const DEFAULT_SERVICE_PAYMENT_AMOUNT_PAISE = 100;

const SERVICE_PAYMENT_OVERRIDES = {
  gst: { amountPaise: 99900 },
  itr: { amountPaise: 49900 },
  shop: { amountPaise: 29900 },
  rent: { amountPaise: 1000 },
  loan: { amountPaise: 1000 },
  udyam: { amountPaise: 29900 },
  food: { amountPaise: 49900 },
  'project-report': { amountPaise: 299900 },
};

const isPaymentFlagEnabled = (value) => String(value || '').trim().toLowerCase() === 'true';

const isServicePaymentEnabled = () =>
  isPaymentFlagEnabled(process.env.REACT_APP_ENABLE_SERVICE_PAYMENT) ||
  isPaymentFlagEnabled(process.env.ENABLE_SERVICE_PAYMENT);

const getServicePaymentConfig = (serviceId) => {
  const override = SERVICE_PAYMENT_OVERRIDES[String(serviceId || '').trim()] || {};
  const amountPaise = Number.parseInt(
    String(override.amountPaise ?? DEFAULT_SERVICE_PAYMENT_AMOUNT_PAISE),
    10
  );
  const currency = String(override.currency || DEFAULT_CURRENCY).trim() || DEFAULT_CURRENCY;

  return {
    amountPaise,
    currency,
  };
};

const formatPaymentAmount = (amountPaise, currency = DEFAULT_CURRENCY) => {
  const normalizedAmount = Number(amountPaise);

  if (!Number.isFinite(normalizedAmount) || normalizedAmount <= 0) {
    return '';
  }

  const amount = (normalizedAmount / 100).toFixed(2);

  if (currency === 'INR') {
    return `Rs ${amount}`;
  }

  return `${currency} ${amount}`;
};

module.exports = {
  DEFAULT_CURRENCY,
  DEFAULT_SERVICE_PAYMENT_AMOUNT_PAISE,
  SERVICE_PAYMENT_OVERRIDES,
  formatPaymentAmount,
  getServicePaymentConfig,
  isServicePaymentEnabled,
};
